import './drawing-map-controls.css';
import React from 'react';
import { iconPen, iconCancel, iconApply } from '../../util/icons';

export interface IDrawingMapControls {
  isDrawing: boolean;
  haveShape?: boolean;
  enableDrawing(): void;
  applyDrawing(): void;
  cancelDrawing(): void;
  removeBoundary(): void;
}

export const DrawingMapControls: React.FC<IDrawingMapControls> = props => {
  return (
    <div className={props.isDrawing ? "drawing-map-controls drawing-map-controls-isDrawing" : "drawing-map-controls"}>
      {props.isDrawing &&
        <div className="drawing-map-controls-notice">Draw a shape around the area you would like to search</div>
      }
      {props.isDrawing
        ?
        <div className="map-draw-controls">
          <button className="button-cancel" id="drawing-map-controls-drawing-mode-cancel-button" type="button" onClick={props.cancelDrawing}>
            <div className="drawing-map-controls-button-icon">{iconCancel}</div>
            <div>Cancel</div>
          </button>
          <button disabled={!props.haveShape} className="button-confirm" id="drawing-map-controls-drawing-mode-apply-button" type="button" onClick={props.applyDrawing}>
            <div className="drawing-map-controls-button-icon">{iconApply}</div>
            <div>Apply</div>
          </button>
        </div>
        :
        <div className="map-draw-controls">
          {(props.haveShape && !props.isDrawing)
            ? <button id="button-cancel" type="button" className="button-cancel" onClick={props.removeBoundary}>
              <div className="drawing-map-controls-button-icon">{iconCancel}</div>
              <div>Remove<br />Boundary</div>
            </button>
            : <button className="drawing-map-controls-button" id="drawing-map-controls-drawing-mode-button" type="button" onClick={props.enableDrawing}>
              <div className="drawing-map-controls-button-icon">{iconPen}</div>
              <div>Draw</div>
            </button>
          }
        </div>
      }
    </div>
  );
}

export default DrawingMapControls;
